module.exports = __webpack_public_path__ + "static/media/uniform_female_front.fada7b22.png";